import React, { useState, useEffect } from 'react';
import './LGPDTermsPage.css';
import logo from '../assets/logo.png';

export default function LGPDPrivacyPage() {
  const [activeSection, setActiveSection] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const sections = [
    { id: 'intro', label: 'Introdução' },
    { id: 'identificacao', label: '1. Identificação do responsável' },
    { id: 'aplicacao', label: '2. Aplicação desta Política' },
    { id: 'dados-pessoais', label: '3. Dados pessoais que podemos tratar' },
    { id: 'origem', label: '4. Origem dos dados' },
    { id: 'finalidades', label: '5. Finalidades do tratamento' },
    { id: 'bases-legais', label: '6. Bases legais' },
    { id: 'responsabilidades', label: '7. Responsabilidades dos usuários' },
    { id: 'compartilhamento', label: '8. Compartilhamento de dados' },
    { id: 'transferencia', label: '9. Transferência internacional' },
    { id: 'armazenamento', label: '10. Armazenamento e retenção' },
    { id: 'seguranca', label: '11. Segurança da informação' },
    { id: 'senhas', label: '12. Senhas e acesso à conta' },
    { id: 'cookies', label: '13. Cookies' },
    { id: 'automatizadas', label: '14. Decisões automatizadas' },
    { id: 'direitos', label: '15. Direitos dos titulares' },
    { id: 'correcao', label: '16. Correção ou contestação' },
    { id: 'criancas', label: '17. Crianças e adolescentes' },
    { id: 'incidentes', label: '18. Incidentes de segurança' },
    { id: 'alteracoes', label: '19. Alterações nesta Política' },
    { id: 'contato', label: '20. Contato' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const sectionElements = sections.map(s => document.getElementById(s.id)).filter(Boolean);
      for (let i = sectionElements.length - 1; i >= 0; i--) {
        const el = sectionElements[i];
        const rect = el.getBoundingClientRect();
        if (rect.top <= 120) {
          setActiveSection(sections[i].id);
          break;
        }
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <div className="lgpd-root">
      {/* Header */}
      <header className="lgpd-header">
        <div className="container">
          <div className="lgpd-header-inner">
            <a href="/" className="lgpd-logo"><img src={logo} alt="AnaliseCentral" style={{height: '100px'}} /></a>
            <nav className="lgpd-header-nav">
              <a href="/">Página Inicial</a>
              <a href="/lgpd/terms">Termos de Uso</a>
              <a href="#" className="active">Política de Privacidade</a>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero */}
      <div className="lgpd-hero">
        <div className="container">
          <span className="lgpd-hero-label">Documento Legal</span>
          <h1>Política de Privacidade</h1>
          <p className="lgpd-hero-meta">
            <span>Última atualização: <strong>01 de Fevereiro de 2025</strong></span>
            <span className="dot">•</span>
            <span>Versão: <strong>1.0</strong></span>
          </p>
        </div>
      </div>

      <div className="lgpd-layout container">
        {/* Sidebar */}
        <aside className={`lgpd-sidebar ${mobileMenuOpen ? 'open' : ''}`}>
          <button 
            className="lgpd-mobile-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <span>📑 Índice da Política</span>
            <span className="chevron">{mobileMenuOpen ? '▲' : '▼'}</span>
          </button>
          <nav className="lgpd-toc">
            <div className="toc-title">Índice</div>
            {sections.map(s => (
              <button
                key={s.id}
                className={`toc-link ${activeSection === s.id ? 'active' : ''}`}
                onClick={() => scrollTo(s.id)}
              >
                {s.label}
              </button>
            ))}
          </nav>
        </aside>

        {/* Content */}
        <main className="lgpd-content">
          {/* Intro */}
          <section id="intro" className="lgpd-section">
            <div className="intro-box">
              <p>
                A sua privacidade é importante para nós. Esta Política de Privacidade explica como a 
                <strong> Análise Cadastral</strong> coleta, utiliza, armazena, compartilha e protege dados pessoais 
                durante o acesso ao nosso site, a criação de contas, a compra de créditos e a utilização dos 
                serviços de consulta cadastral.
              </p>
              <p>
                Ao acessar ou utilizar a plataforma, recomendamos que você leia atentamente este documento.
              </p>
            </div>
          </section>

          {/* 1. Identificação do responsável */}
          <section id="identificacao" className="lgpd-section">
            <h2>1. Identificação do responsável</h2>
            <p>
              Para os dados relacionados ao cadastro dos usuários, funcionamento da plataforma, pagamentos, 
              segurança, atendimento e demais operações descritas nesta Política, a empresa atua como 
              <strong> controladora dos dados pessoais</strong>.
            </p>
            <p>
              A classificação da empresa como controladora ou operadora em relação aos dados utilizados nas 
              consultas poderá variar conforme a origem dos dados, a finalidade da operação e os contratos aplicáveis.
            </p>
          </section>

          {/* 2. Aplicação desta Política */}
          <section id="aplicacao" className="lgpd-section">
            <h2>2. Aplicação desta Política</h2>
            <p>Esta Política se aplica:</p>
            <ul>
              <li>aos visitantes do site;</li>
              <li>aos usuários cadastrados na plataforma;</li>
              <li>aos compradores de consultas avulsas;</li>
              <li>aos clientes que adquirirem créditos ou pacotes de consultas;</li>
              <li>às pessoas que entrarem em contato com nosso atendimento;</li>
              <li>aos titulares cujos dados possam estar presentes em consultas realizadas por usuários autorizados.</li>
            </ul>
            <div className="alert-box alert-info">
              <span className="alert-icon">ℹ️</span>
              <span>Esta Política não se aplica a sites, aplicativos ou serviços de terceiros acessados por meio de links externos.</span>
            </div>
          </section>

          {/* 3. Dados pessoais */}
          <section id="dados-pessoais" className="lgpd-section">
            <h2>3. Dados pessoais que podemos tratar</h2>
            <p>Dependendo da forma como você utiliza a plataforma, podemos tratar as seguintes categorias de informações.</p>

            <h3>3.1. Dados de cadastro e identificação</h3>
            <ul>
              <li>Nome completo;</li>
              <li>CPF ou CNPJ;</li>
              <li>telefone;</li>
              <li>endereço de e-mail.</li>
            </ul>
            <div className="info-box">
              <span className="info-icon">🔒</span>
              <span>As senhas devem ser armazenadas de maneira protegida e não são acessíveis em texto aberto pela equipe da Análise Cadastral.</span>
            </div>

            <h3>3.2. Dados de compra e pagamento</h3>
            <ul>
              <li>Pacote ou serviço adquirido;</li>
              <li>Valor e data da compra;</li>
              <li>Quantidade de créditos;</li>
              <li>Créditos promocionais;</li>
              <li>Histórico de recargas;</li>
              <li>Meio de pagamento;</li>
              <li>Situação do pagamento;</li>
              <li>Dados necessários para emissão de comprovantes e documentos fiscais.</li>
            </ul>
            <p>
              Quando o pagamento for processado por uma empresa especializada, os dados completos do cartão 
              poderão ser tratados diretamente pelo provedor de pagamento, de acordo com sua própria política de privacidade.
            </p>

            <h3>3.3. Dados relacionados às consultas</h3>
            <p>A plataforma poderá permitir pesquisas a partir de:</p>
            <ul>
              <li>CPF;</li>
              <li>Nome;</li>
              <li>Telefone;</li>
              <li>Endereço de e-mail;</li>
              <li>Nome associado a uma transação PIX;</li>
              <li>Seis dígitos centrais de um documento exibido em uma transação PIX;</li>
              <li>Outras informações apresentadas na plataforma.</li>
            </ul>
            <p>Também poderemos registrar:</p>
            <ul>
              <li>tipo de consulta realizada;</li>
              <li>informação utilizada como parâmetro;</li>
              <li>usuário responsável pela consulta;</li>
              <li>data e horário;</li>
              <li>endereço IP;</li>
              <li>resultado apresentado;</li>
              <li>arquivo gerado;</li>
              <li>finalidade declarada pelo usuário;</li>
              <li>registros de acesso ou download do resultado.</li>
            </ul>
            <div className="alert-box">
              <span className="alert-icon">⚠️</span>
              <span>As consultas podem apresentar possíveis correspondências. Um resultado não deve ser interpretado isoladamente como confirmação definitiva de identidade, titularidade, vínculo ou responsabilidade.</span>
            </div>

            <h3>3.4. Dados técnicos e de navegação</h3>
            <p>Podemos coletar automaticamente:</p>
            <ul>
              <li>endereço IP;</li>
              <li>data e horário de acesso;</li>
              <li>páginas visitadas;</li>
              <li>navegador;</li>
              <li>sistema operacional;</li>
              <li>tipo de dispositivo;</li>
              <li>identificadores de sessão;</li>
              <li>registros de erros;</li>
              <li>ações realizadas na plataforma;</li>
              <li>cookies e tecnologias semelhantes.</li>
            </ul>

            <h3>3.5. Dados de atendimento</h3>
            <p>Quando você entrar em contato conosco, poderemos tratar:</p>
            <ul>
              <li>nome;</li>
              <li>telefone;</li>
              <li>e-mail;</li>
              <li>conteúdo da solicitação;</li>
              <li>histórico de atendimento;</li>
              <li>documentos enviados;</li>
              <li>gravações ou registros de conversas, quando aplicável.</li>
            </ul>
          </section>

          {/* 4. Origem dos dados */}
          <section id="origem" className="lgpd-section">
            <h2>4. Origem dos dados</h2>
            <p>Os dados pessoais poderão ser obtidos:</p>
            <ul>
              <li>diretamente do usuário;</li>
              <li>durante o cadastro ou compra;</li>
              <li>por meio da utilização da plataforma;</li>
              <li>por empresas clientes ou usuários autorizados;</li>
              <li>por fornecedores e parceiros contratados;</li>
              <li>por bases de dados cuja utilização seja permitida pela legislação, contratos ou autorizações aplicáveis;</li>
              <li>por fontes públicas ou de acesso público, observadas as limitações legais;</li>
              <li>por prestadores de pagamento, autenticação, hospedagem e prevenção a fraudes.</li>
            </ul>
            <div className="alert-box alert-info">
              <span className="alert-icon">ℹ️</span>
              <span>O fato de uma informação estar disponível publicamente não elimina a necessidade de finalidade legítima, necessidade, transparência e respeito aos direitos do titular.</span>
            </div>
          </section>

          {/* 5. Finalidades */}
          <section id="finalidades" className="lgpd-section">
            <h2>5. Finalidades do tratamento</h2>
            <p>Podemos utilizar os dados pessoais para:</p>

            <h3>5.1. Prestação dos serviços</h3>
            <ul>
              <li>criar e administrar contas;</li>
              <li>autenticar usuários;</li>
              <li>processar consultas;</li>
              <li>gerar e disponibilizar resultados;</li>
              <li>enviar links para acesso aos arquivos;</li>
              <li>manter o histórico de consultas;</li>
              <li>controlar saldo, créditos e bônus;</li>
              <li>processar compras e recargas;</li>
              <li>emitir comprovantes e documentos fiscais.</li>
            </ul>

            <h3>5.2. Consulta avulsa e criação de conta</h3>
            <p>
              Quando uma consulta avulsa for adquirida, poderemos criar automaticamente uma conta vinculada 
              ao e-mail informado pelo comprador.
            </p>
            <p>Essa conta será utilizada para:</p>
            <ul>
              <li>entregar o resultado da consulta;</li>
              <li>permitir o acesso ao histórico;</li>
              <li>disponibilizar créditos promocionais;</li>
              <li>facilitar futuras consultas;</li>
              <li>permitir a compra de novos pacotes.</li>
            </ul>
            <p>O usuário receberá um link temporário para ativação da conta e criação de uma senha pessoal.</p>

            <h3>5.3. Créditos promocionais</h3>
            <p>
              A Análise Cadastral poderá conceder créditos promocionais como benefício de boas-vindas ou 
              em campanhas específicas.
            </p>
            <p>O usuário será informado sobre:</p>
            <ul>
              <li>quantidade concedida;</li>
              <li>prazo de validade;</li>
              <li>condições de utilização;</li>
              <li>ordem de consumo dos créditos;</li>
              <li>eventual expiração do saldo promocional.</li>
            </ul>
            <p>Os créditos promocionais poderão expirar conforme as regras apresentadas no momento da concessão.</p>

            <h3>5.4. Segurança e prevenção a fraudes</h3>
            <ul>
              <li>validar acessos;</li>
              <li>identificar atividades suspeitas;</li>
              <li>prevenir fraudes;</li>
              <li>impedir utilização indevida;</li>
              <li>proteger usuários, titulares e a plataforma;</li>
              <li>investigar violações dos Termos de Uso;</li>
              <li>manter registros de auditoria.</li>
            </ul>

            <h3>5.5. Atendimento e comunicação</h3>
            <ul>
              <li>responder dúvidas e solicitações;</li>
              <li>enviar comunicações sobre compras e consultas;</li>
              <li>informar alterações relevantes;</li>
              <li>enviar avisos de segurança;</li>
              <li>recuperar acesso à conta;</li>
              <li>comunicar vencimento de créditos promocionais.</li>
            </ul>

            <h3>5.6. Melhoria dos serviços</h3>
            <ul>
              <li>avaliar o desempenho da plataforma;</li>
              <li>corrigir erros;</li>
              <li>desenvolver funcionalidades;</li>
              <li>produzir estatísticas;</li>
              <li>analisar padrões de utilização;</li>
              <li>melhorar a experiência dos usuários.</li>
            </ul>
            <p>Sempre que possível, análises estatísticas serão realizadas com dados agregados ou anonimizados.</p>

            <h3>5.7. Comunicações comerciais</h3>
            <p>Poderemos enviar informações sobre:</p>
            <ul>
              <li>novos serviços;</li>
              <li>pacotes de créditos;</li>
              <li>promoções;</li>
              <li>funcionalidades;</li>
              <li>conteúdos relacionados à plataforma.</li>
            </ul>
            <p>
              O usuário poderá solicitar o cancelamento dessas comunicações a qualquer momento por meio do 
              link de descadastramento ou dos nossos canais de atendimento.
            </p>
            <div className="info-box">
              <span className="info-icon">📧</span>
              <span>Mensagens necessárias para execução do serviço, segurança, entrega de resultados ou administração da conta poderão continuar sendo enviadas.</span>
            </div>
          </section>

          {/* 6. Bases legais */}
          <section id="bases-legais" className="lgpd-section">
            <h2>6. Bases legais</h2>
            <p>O tratamento de dados pessoais poderá ocorrer com fundamento nas hipóteses previstas pela legislação aplicável, incluindo:</p>
            <ul>
              <li>execução de contrato ou de procedimentos solicitados pelo titular;</li>
              <li>cumprimento de obrigação legal ou regulatória;</li>
              <li>exercício regular de direitos em processos judiciais, administrativos ou arbitrais;</li>
              <li>legítimo interesse da Análise Cadastral ou de terceiros, após avaliação dos direitos e expectativas do titular;</li>
              <li>proteção do crédito, quando efetivamente aplicável à finalidade específica;</li>
              <li>prevenção de fraudes e segurança;</li>
              <li>consentimento, quando essa for a base legal adequada.</li>
            </ul>
            <p>A base legal será definida conforme a categoria dos dados, a origem, a finalidade e o contexto de cada operação.</p>
            <div className="highlight-box">
              <span className="highlight-icon">✓</span>
              <span>O consentimento não será utilizado como base genérica para todas as atividades. Quando solicitado, será apresentado de maneira livre, informada e específica.</span>
            </div>
          </section>

          {/* 7. Responsabilidades */}
          <section id="responsabilidades" className="lgpd-section">
            <h2>7. Responsabilidades dos usuários nas consultas</h2>
            <p>O usuário deverá utilizar a plataforma apenas para finalidades legítimas, determinadas e compatíveis com a legislação.</p>
            <p>É proibido utilizar os dados para:</p>
            <ul className="prohibited-list">
              <li>perseguição, ameaça ou constrangimento;</li>
              <li>discriminação;</li>
              <li>exposição pública indevida;</li>
              <li>chantagem ou extorsão;</li>
              <li>fraude;</li>
              <li>invasão de privacidade;</li>
              <li>comercialização ilícita;</li>
              <li>obtenção de vantagem ilegal;</li>
              <li>envio de comunicações abusivas;</li>
              <li>qualquer finalidade criminosa ou não autorizada.</li>
            </ul>
            <p>O usuário é responsável pela legitimidade da finalidade da consulta e pelas decisões tomadas a partir dos resultados.</p>
            <p>
              A Análise Cadastral poderá solicitar justificativas, limitar acessos, suspender contas, 
              cancelar créditos ou comunicar autoridades quando identificar indícios de uso abusivo ou ilegal.
            </p>
          </section>

          {/* 8. Compartilhamento */}
          <section id="compartilhamento" className="lgpd-section">
            <h2>8. Compartilhamento de dados</h2>
            <p>Os dados poderão ser compartilhados, dentro dos limites necessários, com:</p>
            <ul>
              <li>provedores de hospedagem e computação em nuvem;</li>
              <li>fornecedores de bancos de dados e informações cadastrais;</li>
              <li>processadores de pagamento;</li>
              <li>serviços de envio de e-mails, SMS ou mensagens;</li>
              <li>ferramentas de autenticação e segurança;</li>
              <li>empresas de prevenção a fraudes;</li>
              <li>prestadores de suporte e tecnologia;</li>
              <li>serviços contábeis, jurídicos e de auditoria;</li>
              <li>autoridades públicas, judiciais ou regulatórias;</li>
              <li>empresas envolvidas em reorganização societária, fusão, aquisição ou venda de ativos.</li>
            </ul>
            <p>
              Os prestadores contratados deverão tratar os dados conforme instruções, contratos e obrigações 
              de confidencialidade e segurança aplicáveis.
            </p>
            <div className="info-box">
              <span className="info-icon">🔒</span>
              <span>Não divulgamos dados pessoais de maneira indiscriminada. O acesso ocorre conforme as funcionalidades contratadas, as regras da plataforma e a finalidade declarada pelo usuário.</span>
            </div>
          </section>

          {/* 9. Transferência internacional */}
          <section id="transferencia" className="lgpd-section">
            <h2>9. Transferência internacional</h2>
            <p>
              Alguns fornecedores de tecnologia, hospedagem, comunicação, segurança ou análise poderão manter 
              infraestrutura fora do Brasil.
            </p>
            <p>
              Quando houver transferência internacional de dados, serão adotadas medidas compatíveis com a 
              legislação, incluindo contratos, avaliações de segurança e mecanismos reconhecidos pelas autoridades competentes.
            </p>
          </section>

          {/* 10. Armazenamento */}
          <section id="armazenamento" className="lgpd-section">
            <h2>10. Armazenamento e retenção</h2>
            <p>Os dados serão mantidos somente pelo período necessário para:</p>
            <ul>
              <li>prestar os serviços;</li>
              <li>cumprir as finalidades desta Política;</li>
              <li>atender obrigações legais;</li>
              <li>prevenir fraudes;</li>
              <li>preservar registros de segurança;</li>
              <li>exercer direitos em processos;</li>
              <li>responder a solicitações de titulares e autoridades.</li>
            </ul>
            <p>Os prazos poderão variar conforme a categoria:</p>
            <div className="retention-table">
              <div className="retention-row header">
                <span>Categoria</span>
                <span>Prazo de retenção</span>
              </div>
              <div className="retention-row">
                <span>Dados de conta</span>
                <span>Durante a relação com o usuário e pelo período necessário após o encerramento</span>
              </div>
              <div className="retention-row">
                <span>Registros de pagamento e documentos fiscais</span>
                <span>Conforme os prazos legais aplicáveis</span>
              </div>
              <div className="retention-row">
                <span>Registros de acesso</span>
                <span>Pelo prazo exigido pela legislação</span>
              </div>
              <div className="retention-row">
                <span>Histórico de consultas</span>
                <span><strong>30 dias</strong></span>
              </div>
              <div className="retention-row">
                <span>Arquivos de resultados</span>
                <span><strong>30 dias</strong></span>
              </div>
              <div className="retention-row">
                <span>Atendimentos</span>
                <span><strong>30 dias</strong></span>
              </div>
              <div className="retention-row">
                <span>Créditos promocionais</span>
                <span>Conforme as condições informadas na campanha</span>
              </div>
            </div>
            <p>
              Após o término do prazo, os dados poderão ser eliminados, anonimizados ou conservados quando 
              houver fundamento legal para sua manutenção.
            </p>
          </section>

          {/* 11. Segurança */}
          <section id="seguranca" className="lgpd-section">
            <h2>11. Segurança da informação</h2>
            <p>Adotamos medidas administrativas, organizacionais e técnicas destinadas a proteger os dados contra:</p>
            <ul>
              <li>acesso não autorizado;</li>
              <li>perda;</li>
              <li>alteração;</li>
              <li>destruição;</li>
              <li>vazamento;</li>
              <li>uso indevido;</li>
              <li>tratamento incompatível com a finalidade.</li>
            </ul>
            <p>Essas medidas podem incluir:</p>
            <ul>
              <li>controle de acesso;</li>
              <li>autenticação;</li>
              <li>senhas protegidas;</li>
              <li>criptografia em trânsito;</li>
              <li>registros de auditoria;</li>
              <li>monitoramento de atividades;</li>
              <li>restrição de permissões;</li>
              <li>cópias de segurança;</li>
              <li>atualização de sistemas;</li>
              <li>treinamento de equipes;</li>
              <li>gestão de fornecedores.</li>
            </ul>
            <div className="alert-box alert-info">
              <span className="alert-icon">🛡️</span>
              <span>Nenhum sistema é completamente imune a riscos. Caso identifique atividade suspeita, entre em contato imediatamente pelo e-mail <a href="mailto:suporte@analisecadastral.com.br">suporte@analisecadastral.com.br</a>.</span>
            </div>
          </section>

          {/* 12. Senhas */}
          <section id="senhas" className="lgpd-section">
            <h2>12. Senhas e acesso à conta</h2>
            <p>O usuário é responsável por manter suas credenciais em segurança.</p>
            <p>Recomendamos:</p>
            <ul>
              <li>não compartilhar a senha;</li>
              <li>utilizar uma senha exclusiva;</li>
              <li>não reutilizar senhas de outros serviços;</li>
              <li>encerrar a sessão em dispositivos compartilhados;</li>
              <li>comunicar acessos suspeitos imediatamente.</li>
            </ul>
            <div className="alert-box">
              <span className="alert-icon">🔐</span>
              <span>A Análise Cadastral <strong>nunca</strong> solicitará sua senha completa por e-mail, telefone ou mensagem.</span>
            </div>
            <p>
              Em contas criadas após uma consulta avulsa, será enviado um link temporário e individual 
              para definição da senha.
            </p>
          </section>

          {/* 13. Cookies */}
          <section id="cookies" className="lgpd-section">
            <h2>13. Cookies</h2>
            <p>Podemos utilizar cookies necessários para:</p>
            <ul>
              <li>manter a sessão do usuário;</li>
              <li>autenticar acessos;</li>
              <li>preservar preferências;</li>
              <li>aumentar a segurança;</li>
              <li>prevenir fraudes;</li>
              <li>entender o funcionamento do site;</li>
              <li>medir desempenho;</li>
              <li>melhorar a experiência.</li>
            </ul>
            <p>
              Cookies não essenciais, especialmente os utilizados para publicidade ou análise comportamental, 
              serão utilizados conforme as escolhas apresentadas no banner ou painel de preferências, quando aplicável.
            </p>
            <div className="info-box">
              <span className="info-icon">🍪</span>
              <span>O usuário poderá ajustar os cookies nas configurações do navegador. A desativação de cookies necessários poderá impedir o funcionamento de algumas áreas da plataforma.</span>
            </div>
          </section>

          {/* 14. Decisões automatizadas */}
          <section id="automatizadas" className="lgpd-section">
            <h2>14. Decisões e correspondências automatizadas</h2>
            <p>A plataforma poderá utilizar processos automatizados para:</p>
            <ul>
              <li>pesquisar registros;</li>
              <li>comparar informações;</li>
              <li>organizar resultados;</li>
              <li>indicar possíveis correspondências;</li>
              <li>detectar atividades suspeitas;</li>
              <li>prevenir fraudes.</li>
            </ul>
            <div className="alert-box">
              <span className="alert-icon">⚠️</span>
              <span>Uma correspondência automatizada não representa, por si só, confirmação definitiva de identidade ou vínculo.</span>
            </div>
            <p>
              Quando uma decisão baseada exclusivamente em tratamento automatizado produzir efeitos relevantes 
              sobre o titular, ele poderá solicitar informações sobre os critérios utilizados e, quando aplicável, 
              a revisão da decisão.
            </p>
          </section>

          {/* 15. Direitos dos titulares */}
          <section id="direitos" className="lgpd-section">
            <h2>15. Direitos dos titulares</h2>
            <p>Nos termos da legislação aplicável, o titular poderá solicitar:</p>
            <ul className="rights-list">
              <li>confirmação da existência de tratamento;</li>
              <li>acesso aos dados;</li>
              <li>correção de informações incompletas, inexatas ou desatualizadas;</li>
              <li>anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados irregularmente;</li>
              <li>portabilidade, quando aplicável;</li>
              <li>informação sobre compartilhamentos;</li>
              <li>informação sobre a possibilidade de negar consentimento;</li>
              <li>revogação do consentimento;</li>
              <li>oposição a determinados tratamentos;</li>
              <li>revisão de decisões automatizadas, quando aplicável;</li>
              <li>eliminação de dados tratados com consentimento, ressalvadas as hipóteses legais de conservação;</li>
              <li>apresentação de reclamação à Autoridade Nacional de Proteção de Dados.</li>
            </ul>
            <p>Para exercer seus direitos, envie uma solicitação para:</p>
            <div className="contact-box">
              <a href="mailto:suporte@analisecadastral.com.br">suporte@analisecadastral.com.br</a>
            </div>
            <p>
              Poderemos solicitar informações adicionais para confirmar a identidade do solicitante e evitar 
              que dados sejam entregues a terceiros não autorizados.
            </p>
            <div className="info-box">
              <span className="info-icon">📋</span>
              <span>Algumas solicitações poderão não ser atendidas integralmente quando a conservação ou o tratamento forem necessários para cumprimento de obrigação legal, prevenção a fraudes, segurança, exercício de direitos ou outras hipóteses permitidas pela legislação.</span>
            </div>
          </section>

          {/* 16. Correção */}
          <section id="correcao" className="lgpd-section">
            <h2>16. Correção ou contestação de resultados</h2>
            <p>
              Caso um titular identifique informação incorreta, desatualizada ou atribuída indevidamente a ele, 
              poderá solicitar análise por meio do e-mail:
            </p>
            <div className="contact-box">
              <a href="mailto:suporte@analisecadastral.com.br">suporte@analisecadastral.com.br</a>
            </div>
            <p>A solicitação deverá conter, quando possível:</p>
            <ul>
              <li>nome completo;</li>
              <li>forma de contato;</li>
              <li>descrição da informação questionada;</li>
              <li>documento que permita confirmar a identidade;</li>
              <li>elementos que demonstrem o possível erro.</li>
            </ul>
            <p>
              A Análise Cadastral avaliará a solicitação e poderá encaminhá-la ao fornecedor ou responsável 
              pela fonte da informação, quando necessário.
            </p>
          </section>

          {/* 17. Crianças e adolescentes */}
          <section id="criancas" className="lgpd-section">
            <h2>17. Crianças e adolescentes</h2>
            <p>A plataforma não é destinada à contratação ou utilização direta por crianças e adolescentes.</p>
            <p>
              Não permitimos a criação consciente de contas por menores de 18 anos sem a participação e 
              autorização de seu responsável legal, quando exigida.
            </p>
            <p>
              Eventuais dados de crianças ou adolescentes somente poderão ser tratados quando houver 
              fundamento legal adequado, necessidade comprovada e observância de seu melhor interesse.
            </p>
          </section>

          {/* 18. Incidentes */}
          <section id="incidentes" className="lgpd-section">
            <h2>18. Incidentes de segurança</h2>
            <p>Caso ocorra um incidente de segurança envolvendo dados pessoais, adotaremos medidas para:</p>
            <ul>
              <li>avaliar a natureza e a extensão do evento;</li>
              <li>conter os riscos;</li>
              <li>reduzir possíveis danos;</li>
              <li>corrigir vulnerabilidades;</li>
              <li>preservar evidências;</li>
              <li>comunicar titulares e autoridades quando exigido pela legislação.</li>
            </ul>
          </section>

          {/* 19. Alterações */}
          <section id="alteracoes" className="lgpd-section">
            <h2>19. Alterações nesta Política</h2>
            <p>Esta Política poderá ser atualizada para refletir:</p>
            <ul>
              <li>mudanças na plataforma;</li>
              <li>novas funcionalidades;</li>
              <li>alterações legais ou regulatórias;</li>
              <li>mudanças em fornecedores;</li>
              <li>aprimoramentos de segurança;</li>
              <li>novas práticas de tratamento.</li>
            </ul>
            <p>A versão atualizada será publicada no site com a indicação da data de revisão.</p>
            <p>
              Quando a alteração for relevante, poderemos comunicá-la por e-mail, aviso na plataforma ou 
              outro canal adequado.
            </p>
          </section>

          {/* 20. Contato */}
          <section id="contato" className="lgpd-section">
            <h2>20. Contato</h2>
            <p>Para dúvidas, solicitações ou exercício de direitos relacionados a dados pessoais, entre em contato:</p>
            <div className="atendimento-card">
              <div className="atendimento-row">
                <span className="atendimento-label">E-mail</span>
                <a href="mailto:suporte@analisecadastral.com.br" className="atendimento-value">suporte@analisecadastral.com.br</a>
              </div>
              <div className="atendimento-row">
                <span className="atendimento-label">Prazo estimado de resposta</span>
                <span className="atendimento-value">15 dias úteis</span>
              </div>
            </div>
            <p>
              O titular também poderá apresentar uma petição à <strong>Autoridade Nacional de Proteção de Dados</strong>, 
              observados os procedimentos disponibilizados pela própria autoridade.
            </p>
            <p className="final-note">
              Ao utilizar a plataforma, o usuário confirma que leu e concordou com esta Política de Privacidade.
            </p>
          </section>
        </main>
      </div>

      {/* Footer */}
      <footer className="lgpd-footer">
        <div className="container">
          <div className="lgpd-footer-inner">
            <p>© Análise Central. Todos os direitos reservados.</p>
            <div className="lgpd-footer-links">
              <a href="/">Página Inicial</a>
              <a href="/lgpd/terms">Termos de Uso</a>
              <a href="/lgpd/exclusion">LGPD</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}